<template>
    <v-container fill-height>
        <v-row>
            <v-col>
                <v-stepper v-model="onstep" class="xl">
                    <v-stepper-header>
                        <v-stepper-step :complete="onstep > 1" step="1" editable>
                            Order Form
                        </v-stepper-step>
                        <v-divider />
                        <v-stepper-step :complete="onstep > 2" step="2">
                            Shipping Info
                        </v-stepper-step>
                        <v-divider />
                        <v-stepper-step step="3">
                            Confirmation
                        </v-stepper-step>
                    </v-stepper-header>
                    <v-stepper-items>
                        <v-stepper-content step="1">
                            <!-- show order type for Simplex Grinnell -->
                            <v-card tile v-if="clientId == 116">
                                <v-card-text>
                                    Order Type:
                                    <v-radio-group
                                        v-model="ordertype" row mandatory>
                                        <v-radio
                                            label="High Volume"
                                            value="highvolume" />
                                        <v-radio
                                            label="Excess Inventory"
                                            value="excess" />
                                    </v-radio-group>
                                </v-card-text>
                            </v-card>
                            <v-card tile>
                                <v-form ref="step2_form" v-model="valid">
                                    <v-card-text>
                                        <v-simple-table fixed-header>
                                            <template #default>
                                                <thead>
                                                    <tr>
                                                        <th class="text-left">
                                                            Part Code
                                                        </th>
                                                        <th class="text-left">
                                                            Part Description
                                                        </th>
                                                        <th class="text-left">
                                                            Manufacturer
                                                        </th>
                                                        <th class="text-left">
                                                            Available
                                                        </th>
                                                        <th class="text-left">
                                                            Quantity
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(item, index) in order.OrderItems" :key="item.part_code">
                                                        <td>{{ item.PartCode }}</td>
                                                        <td>{{ item.Description }}</td>
                                                        <td>{{ item.Manufacturer }}</td>
                                                        <td>{{ item.AvailableQty }}</td>
                                                        <td>
                                                            <v-text-field
                                                                v-mask="'#####'"
                                                                :rules="[v => !!v && v > 0 || 'Quantity is required', v => (v <= item.AvailableQty) || 'Quantity not available']"
                                                                style="max-width:75px"
                                                                v-model="item.OrderQty"
                                                                required />
                                                        </td>
                                                        <td>
                                                            <v-icon @click="removePartFromOrder(index)">
                                                                clear
                                                            </v-icon>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </template>
                                        </v-simple-table>
                                    </v-card-text>
                                    <v-card-actions>
                                        <v-btn color="green" @click="partsDialog=true">
                                            Add Parts
                                        </v-btn>
                                        <v-spacer />
                                        <v-btn
                                            text
                                            :disabled="order.OrderItems.length == 0"
                                            @click="order.OrderItems = []">
                                            Reset
                                        </v-btn>
                                        <v-btn color="primary" :disabled="!valid" @click="onstep = 2">
                                            Continue
                                        </v-btn>
                                    </v-card-actions>
                                </v-form>
                            </v-card>
                        </v-stepper-content>
                        <v-stepper-content step="2">
                            <v-card tile>
                                <v-card-text height="400px">
                                    <v-card>
                                        <v-card-text>
                                            <v-form v-model="shippingvalid" ref="shippingform" validation>
                                                <v-row dense>
                                                    <v-col cols="12" md="5">
                                                        <v-autocomplete
                                                            ref="shipbranchid"
                                                            :items="branches"
                                                            item-text="branch_display_name"
                                                            item-value="brid"
                                                            v-model="shipbranch"
                                                            return-object
                                                            dense
                                                            menu-props="{ closeOnClick:true, closeOnContentClick:true, maxHeight:400, transition:scale-transition }"
                                                            @change="$refs.shipbranchid.blur()"
                                                            label="Branch"
                                                            placeholder="Pick branch to lookup address"
                                                            clearable
                                                            :loading="branchesloading" />
                                                    </v-col>
                                                    <v-col cols="12" md="4">
                                                        <v-text-field
                                                            label="PO Number"
                                                            v-model="order.PONumber"
                                                            counter="25"
                                                            :rules="[v => !!v || 'PO Number is required', v => /^[\w-]+$/g.test(v) || 'Only alphanumeric characters or underscores', v => !v || v.length <= 25 || 'Max 25 characters']"
                                                            dense />
                                                    </v-col>
                                                    <v-col cols="12" md="3" v-if="!isREVOrder()">
                                                        <v-menu
                                                            v-model="datepickMenu"
                                                            :close-on-content-click="false"
                                                            :nudge-right="40"
                                                            transition="scale-transition"
                                                            offset-y
                                                            min-width="260px">
                                                            <template #activator="{ on }">
                                                                <v-text-field
                                                                    v-model="order.NeedByDate"
                                                                    label="Need by date"
                                                                    prepend-icon="event"
                                                                    readonly
                                                                    v-on="on"
                                                                    :rules="[v => !!v || 'Need By Date is required']" />
                                                            </template>
                                                            <v-date-picker
                                                                v-model="order.NeedByDate"
                                                                @input="datepickMenu = false"
                                                                :min="new Date() | moment('YYYY-MM-DD')"
                                                                :max="new Date() | moment('add', '30 days', 'YYYY-MM-DD')" />
                                                        </v-menu>
                                                    </v-col>
                                                    <v-col cols="12" md="5">
                                                        <v-text-field
                                                            v-if="!isREVOrder()"
                                                            label="Company"
                                                            v-model="order.ShipToCompany"
                                                            :rules="[v => !!v || 'Company is required']"
                                                            dense />
                                                    </v-col>
                                                    <v-col cols="12" md="8">
                                                        <v-text-field :disabled="isREVOrder() && !order.UpdateBranchAddress" label="Address Line 1" v-model="order.ShipToAddr1" :rules="[v => !!v || 'Address is required']" dense />
                                                    </v-col>
                                                    <v-col cols="12" md="8">
                                                        <v-text-field :disabled="isREVOrder() && !order.UpdateBranchAddress" label="Address Line 2" v-model="order.ShipToAddr2" dense />
                                                    </v-col>
                                                    <v-col cols="12" md="6">
                                                        <v-text-field
                                                            :disabled="isREVOrder() && !order.UpdateBranchAddress"
                                                            label="City"
                                                            v-model="order.ShipToCity"
                                                            :rules="[v => !!v || 'City is required']"
                                                            dense />
                                                    </v-col>
                                                    <v-col cols="12" md="3">
                                                        <v-text-field
                                                            :disabled="isREVOrder() && !order.UpdateBranchAddress"
                                                            label="State/Province/Region"
                                                            v-model="order.ShipToState"
                                                            :rules="[v => !!v || 'State is required']"
                                                            dense />
                                                    </v-col>
                                                    <v-col cols="12" md="3">
                                                        <v-text-field :disabled="isREVOrder() && !order.UpdateBranchAddress" label="ZIP/Postal Code" v-model="order.ShipToZip" v-mask="'#####'" :rules="[v => !!v || 'ZIP is required']" dense />
                                                    </v-col>
                                                    <v-col cols="12" md="8">
                                                        <v-checkbox v-if="isREVOrder()" v-model="order.UpdateBranchAddress" label="Select to edit (updates branch address upon order submission)" />
                                                    </v-col>
                                                    <v-col cols="12" md="8">
                                                        <v-text-field
                                                            v-if="isREVOrder()" label="Notes" hint="Special instructions for shipping and handling" v-model="order.Description" dense
                                                            counter="240"
                                                            :rules="[v => !v || v.length <= 240 || 'Max 240 characters']" />
                                                        <v-text-field
                                                            v-if="!isREVOrder()" label="Description" hint="Optional information printed on the shipping label" v-model="order.Description" dense
                                                            counter="240"
                                                            :rules="[v => !v || v.length <= 240 || 'Max 240 characters']" />
                                                    </v-col>
                                                </v-row>
                                            </v-form>
                                        </v-card-text>
                                    </v-card>
                                </v-card-text>
                                <v-card-actions>
                                    <v-spacer />
                                    <v-btn text @click="resetShipping()">
                                        Reset
                                    </v-btn>
                                    <v-btn
                                        color="primary"
                                        @click="submitOrder()"
                                        :disabled="!shippingvalid || isOrderSubmitting"
                                        :loading="isOrderSubmitting">
                                        Submit Order
                                    </v-btn>
                                </v-card-actions>
                                <v-card-text
                                    class="text-center"
                                    style="font-size:0.35rem; color:lightgray;"
                                    v-if="clientId == 144 || clientId == 102 || clientId == 133">
                                    <span style="cursor: pointer;" @click="submitOrder(true)">
                                        Submit Test Order
                                    </span>
                                </v-card-text>
                            </v-card>
                        </v-stepper-content>
                        <v-stepper-content step="3">
                            <v-card tile>
                                <v-card-text height="400px">
                                    <div class="d-flex headline">
                                        <span class="mr-3">Order Result:</span>
                                        <span
                                            :class="[this.orderResponse.Success ? 'green--text' : 'red--text']">{{ this.orderResponse.Success ? 'Order Submitted' : 'Order Failed' }}</span>
                                    </div>
                                    <div class="d-flex flex-column" v-if="orderResponse.Success">
                                        <div class="d-flex subtitle-1 font-weight-bold">
                                            <span class="mr-3">PO Number:</span>
                                            <span>{{ this.orderResponse.ReqNumber }}</span>
                                        </div>

                                        <div class="d-flex subtitle-1 font-weight-bold">
                                            <span class="mr-3">Order Number:</span>
                                            <span>{{ this.orderResponse.ClientOrderNumber }}</span>
                                        </div>
                                    </div>
                                    <div v-else class="d-flex subtitle-1 font-weight-bold">
                                        <span>{{ orderResponse.Error }}</span>
                                    </div>
                                </v-card-text>
                                <v-card-text>
                                    <v-simple-table fixed-header>
                                        <template #default>
                                            <thead>
                                                <tr>
                                                    <th class="text-left">
                                                        Part Code
                                                    </th>
                                                    <th class="text-left">
                                                        Description
                                                    </th>
                                                    <th class="text-left">
                                                        Manufacturer
                                                    </th>
                                                    <th class="text-left">
                                                        Quantity
                                                    </th>
                                                    <th
                                                        v-if="orderResponse.Error=='Quantity Not Available'"
                                                        class="text-left">
                                                        Available Quantity
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(item) in orderResponse.OrderDetails" :key="item.part_code">
                                                    <td>{{ item.PartCode }}</td>
                                                    <td>{{ item.Description }}</td>
                                                    <td>{{ item.Manufacturer }}</td>
                                                    <td>{{ item.Qty }}</td>
                                                    <td v-if="item.message =='Quantity Not Available'">
                                                        {{ item.availableQty }}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </template>
                                    </v-simple-table>
                                </v-card-text>

                                <!-- End Test -->

                                <v-card-actions>
                                    <v-spacer />
                                    <v-btn color="primary" @click="startNewOrder()">
                                        Create Another Order
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-stepper-content>
                    </v-stepper-items>
                </v-stepper>
            </v-col>
        </v-row>
        <v-dialog v-model="partsDialog">
            <v-card>
                <v-card-title>
                    Parts in Inventory
                    <v-spacer />
                    <v-text-field
                        class="search-field"
                        v-model="search"
                        append-icon="search"
                        label="Search"
                        single-line
                        hide-details />
                </v-card-title>
                <v-card-text>
                    <v-data-table
                        :items="part_inventory"
                        v-model="order.OrderItems"
                        :headers="headers"
                        item-key="PartCode"
                        :items-per-page="15"
                        :search="search"
                        show-select
                        :loading="partsloading">
                        <template #header.data-table-select /> <!-- suppress 'select all' in header -->
                        <template #item.data-table-select="{ item, isSelected, select }">
                            <v-simple-checkbox :value="isSelected" @input="select($event)" v-ripple />
                        </template>
                    </v-data-table>
                </v-card-text>
                <v-card-actions class="mr-5">
                    <v-spacer />
                    <v-btn color="primary" default @click="partsDialog=false">
                        Back to Cart
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import config from "../config";
import axios from "axios";
import moment from "moment";

export default {
    name: "Order",
    components: {},
    data: () => ({
        onstep: 1,
        partsDialog: false,
        datepickMenu: false,
        QGOrderNumber: null,
        order: {
            PONumber: "",
            OrderDate: "",
            NeedByDate: "",
            RequestedBy: "",
            ShipToCompany: "",
            ShipToAddr1: "",
            ShipToAddr2: "",
            ShipToCity: "",
            ShipToState: "",
            ShipToZip: "",
            BranchId: "",
            BranchName: "",
            UpdateBranchAddress: false,
            Description: "",
            NumOrderLines: 0,
            OrderItems: [],
        },
        headers: [{
            text: "Part Code",
            align: "left",
            sortable: true,
            value: "PartCode",
            filterable: true,
        },
        {
            text: "Part Description",
            align: "left",
            sortable: true,
            value: "Description",
            filterable: true,
        },
        {
            text: "Manufacturer",
            align: "left",
            sortable: true,
            value: "Manufacturer",
            filterable: true,
        },
        {
            text: "Avaiable Quantity",
            align: "right",
            sortable: false,
            value: "AvailableQty",
            filterable: true,
        }],
        ordertype: null,
        search: "",
        shippingvalid: false,
        isOrderSubmitting: false,
        shipbranch: {},
        partsloading: false,
        recalcinventory: 0,
        branchesloading: false,
        orderprocessing: false,
        orderResponse: {},
        valid: true,
    }),
    computed: {
        clientId()
        {
            let users_client_id = this.$store.state.auth.profile["custom:client_id"]
            let client_id

            if (users_client_id == "999" && this.$store.state.portalsettings.client) 
            {
                // qgistix user w/999, and there is a client in the app setting, we use it
                client_id = String(this.$store.state.portalsettings.client.client_id);
            } // no selected client for QGistix 999 user, or a client who can only be their own client_id
            else 
            {
                client_id = users_client_id;
            }
            return client_id
        },
        quantityNotAvailable() 
        {
            return this.orderResponse.OrderDetails.filter(item => 
                item.Message == "Quantity Not Available");
        },
    },
    asyncComputed: {
        part_inventory: {
            async get() 
            {
                try 
                {
                    this.partsloading = true;

                    let endpoint = this.getOrderInventoryEndpoint()
                    if (endpoint)
                    {
                        let response = await axios.put(config.QDS + endpoint, [],
                            { headers: { Authorization: this.$store.state.auth.idToken } },
                        );

                        // console.log("raw response data:\n" + JSON.stringify(response.data))
                        // mapreduce into our viewmodel
                        let vm_inventory = response.data.reduce((accumulator, i) => 
                        {
                            accumulator.push({
                                PartCode: i.part_code,
                                AvailableQty: i.qty_available,
                                QtyUnit: "EA",
                                OrderQty: null,
                                NeedBy: "",
                                Description: i.description,
                                Manufacturer: i.manufacturer,
                            });
                            return accumulator;
                        }, []);

                        // console.log("mapped response data:\n" + JSON.stringify(vm_inventory))
                        return vm_inventory;
                    }
                    else {return []}

                }
                catch (e) 
                {
                    console.error(e);
                    return [];
                }
                finally 
                {
                    this.partsloading = false;
                }
            },
            watch() 
            {
                this.recalcinventory
            },
            default: [],
        },
        branches: {
            async get() 
            {
                try 
                {
                    this.branchesloading = true

                    let response = await axios.get(
                        config.QDS + `clients/${this.clientId}/branches`,
                        { headers: { Authorization: this.$store.state.auth.idToken } },
                    );
                    return response.data.map(b => ({
                        brid: b.brid,
                        branch_name: b.branch_name,
                        branch_display_name: `${b.brid} - ${b.branch_name}`,
                    }));
                    
                }
                catch (e) 
                {
                    return [];
                }
                finally 
                {
                    this.branchesloading = false
                }
            },
            default: [],
        },
    },
    watch: {
        async shipbranch(newbranch, oldbranch) 
        {
            // console.log("shipbranch changed, oldbranch:\n" + JSON.stringify(oldbranch) + "\nnewbranch:\n" + JSON.stringify(newbranch))
            if (newbranch) 
            {
                
                let response = await axios.get(config.QDS + `clients/${this.clientId}/branch/${newbranch.brid}`,
                    { headers: { Authorization: this.$store.state.auth.idToken } },
                );

                this.order.ShipToCompany = (newbranch.brid == 'WillCall' ? 'Will Call ' : '') + response.data[0].client_name;
                this.order.ShipToAddr1 = response.data[0].addr1;
                this.order.ShipToAddr2 = response.data[0].addr2;
                this.order.ShipToCity = response.data[0].city;
                this.order.ShipToState = response.data[0].state;
                this.order.ShipToZip = response.data[0].zip;
                this.order.BranchId = response.data[0].brid;
                this.order.BranchName = response.data[0].branch_name;
                this.order.UpdateBranchAddress = false
            }
            else 
            {
                this.order.ShipToCompany = "";
                this.order.ShipToAddr1 = "";
                this.order.ShipToAddr2 = "";
                this.order.ShipToCity = "";
                this.order.ShipToState = "";
                this.order.ShipToZip = "";
                this.order.BranchId = "";
                this.order.BranchName = "";
                this.order.UpdateBranchAddress = false
            }
        },
    },
    methods: {
        removePartFromOrder: function(index) 
        {   
            this.order.OrderItems[index].OrderQty = "0";
            this.order.OrderItems.splice(index, 1);
        },
        async resetShipping() 
        {
            // if a branch user, we prefill the shipping address
            if (this.$store.state.auth.profile["custom:brid"]) 
            {
                let response = await axios.get(config.QDS + `clients/${this.$store.state.auth.profile["custom:client_id"]}/branch/${this.$store.state.auth.profile["custom:brid"]}`,
                    { headers: { Authorization: this.$store.state.auth.idToken } },
                );

                this.shipbranch = response.data[0];
                this.order.UpdateBranchAddress = false

            }
            else 
            {
                this.order.ShipToCompany = "";
                this.order.ShipToAddr1 = "";
                this.order.ShipToAddr2 = "";
                this.order.ShipToCity = "";
                this.order.ShipToState = "";
                this.order.ShipToZip = "";
                this.order.BranchId = "";
                this.order.Description = "";
                this.order.UpdateBranchAddress = false
            }
        },
        startNewOrder() 
        {
            this.order.PONumber = "";
            this.order.OrderDate = "";
            this.order.NeedByDate = "";
            this.order.RequestedBy =
        this.$store.state.auth.profile.given_name +
        " " +
        this.$store.state.auth.profile.family_name;
            this.resetShipping();
            this.order.NumOrderLines = 0;
            this.order.OrderItems = [];
            this.onstep = 1;
            this.partsDialog = true;
            this.$refs.shippingform.reset();
            this.QGOrderNumber = null;
        },
        async submitOrder(isTest = false)
        {
            try 
            {
                this.isOrderSubmitting = true
                
                let order_payload = {
                    CheckQtyAvail: true,
                    ClientId: (this.clientId == 128 ? 101 : this.clientId), // 128 is a special case for Everon (ADT Commercial), need to submit as 101
                    PONumber: this.order.PONumber,
                    OrderDate: moment().format("YYYY-MM-DD"),
                    RequestedBy: this.order.RequestedBy,
                    ShipToCompany: this.order.ShipToCompany,
                    ShipToAddr1: this.order.ShipToAddr1,
                    ShipToAddr2: this.order.ShipToAddr2,
                    ShipToCity: this.order.ShipToCity,
                    ShipToState: this.order.ShipToState,
                    ShipToZip: this.order.ShipToZip,
                    BranchId: this.order.BranchId,
                    BranchName: this.order.BranchName,
                    UpdateBranchAddress: this.order.UpdateBranchAddress,
                    Description: this.order.Description,
                    NumOrderLines: this.order.OrderItems.length,
                    OrderItems: [],
                };

                if (isTest)
                {
                    order_payload.isTest = true
                }

                // set source if ordertype is specified (Simplex Grinnell - 116 - only)
                if (this.ordertype)
                {
                    order_payload.Source = "FwdOrderSource"
                    order_payload.SourceChannel = this.ordertype
                }

                if (this.clientId == 102)
                {
                    // we mark it as an excess order, not rdc
                    order_payload.Source = "FwdOrderSource"
                    order_payload.SourceChannel = "excess"
                    // we indicate that it's a manual portal order
                    order_payload.OrderFileName = "PortalManualOrder"

                    if (this.order.BranchId == "WillCall")
                    {
                        order_payload.isHot = true
                    }
                }

                let index = 1;
                this.order.OrderItems.forEach(item => 
                {
                    order_payload.OrderItems.push({
                        OrderLine: index,
                        PartCode: item.PartCode,
                        Qty: item.OrderQty,
                        QtyUnit: item.QtyUnit,
                        NeedBy: this.order.NeedByDate,
                        Manufacturer: item.Manufacturer,
                        Description: item.Description,
                    });
                    index++;
                })

                console.log("order_payload:\n" + JSON.stringify(order_payload));

                this.orderprocessing = true;

                let endpoint = this.getOrderInventoryEndpoint()
                if (endpoint)
                {
                    let response = await axios.post(config.QDS + endpoint, order_payload, { headers: { Authorization: this.$store.state.auth.idToken } })

                    // console.log(response);
                    this.orderResponse = response.data
                    console.log("order response: ", this.orderResponse)
                    this.orderprocessing = false
                    this.onstep = 3
                    this.recalcinventory += 1 // force refresh so inventory is recalculated, reflecting reduction of newly ordered items
                }
            }
            finally
            {
                this.isOrderSubmitting = false
            }
        },
        isREVOrder()
        {
            return this.$route.params.program == "rev" ? true : false
        },
        getOrderInventoryEndpoint()
        {
            let endpoint
            if (this.$route.params.program == "3pl")
            {
                endpoint = `order/3pl/inventory/${this.clientId}/FWD`
            }
            else if (this.$route.params.program == "rev")
            {
                endpoint = `order/rev/inventory/${this.clientId}`
            }
            return endpoint
        },
    },
    mounted() 
    {
        this.startNewOrder();
    },
};
</script>

<style scoped>
.search-field {
  max-width: 300px;
  /* margin-bottom: 50px; */
}
</style>
